import { useEffect, useState } from 'react'
import MainLoader from "./components/common/MainLoader";
import Cookie from './utils/cookie.util.js';
import axios from 'axios';
import { useStore } from './components/providers/StoreContext.jsx';
import MESSAGE from './constants/message.constant.js';
import toasty from './utils/toasty.util.jsx';
import { getIframeToken } from './utils/iframeAuth.util.js';


const AuthenticateHandler = ({ children }) => {

    const [isSessionLoading, setIsSessionLoading] = useState(true);
    const { updateStore } = useStore();

    useEffect(() => {
        getUserSession();
    }, []);

    const getUserSession = async () => {
        try {

            setIsSessionLoading(true);
            const token = await Cookie.get("x-token") || getIframeToken();
            if (token) {
                axios.defaults.headers.Authorization = token;
                axios.defaults.headers['x-client-route'] = window.location.pathname;
                const response = await axios.post(`api/common/session`);
                updateStore({ user: response.data.session, isAuthenticated: true });
            }
        } catch (error) {
            toasty.error(error?.response?.data?.message || MESSAGE.ERROR_AFTER_HOUR)
        }
        finally {
            setIsSessionLoading(false);
        }
    };

    return (
        <>
            {isSessionLoading ? <MainLoader /> : children}
        </>
    );
};

export default AuthenticateHandler;